export default __webpack_public_path__ + "static/media/yw-icons.72144977.woff";